import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { TaraSurvey } from '../components/features/Tara';
import { actions } from '../actions/tara';
import { getUserId } from '../reducers/app/userId';
import { getTaraIsViewingSurvey } from '../reducers/tara/isViewingSurvey';
import { getTaraHasAnsweredSurvey } from '../reducers/tara/hasAnsweredSurvey';
import { getTaraHasMadeIntroduction } from '../reducers/tara/hasMadeIntroduction';
import { getIsFetching } from '../reducers/tara/isFetching';
import { getStatus } from '../reducers/tara/status';
import { getTaraSurvey } from '../reducers/tara/survey';
import { actions as analyticsActions } from '../actions/analytics';

let submittedForm;

class TaraSurveyContainer extends React.PureComponent {
  state = {
    isViewingSurvey: this.props.isViewingSurvey,
  };

  hasSubmitted = false;

  componentDidMount() {
    this.props.taraGetSurveyRequest();
    // this.props.taraSetIsViewingSurvey(true);
  }

  componentWillUnmount() {
    // this.props.taraSetIsViewingSurvey(false);
  }

  get shouldRenderSurvey() {
    const { isViewingSurvey } = this.state;
    const { survey } = this.props;

    return !!survey && isViewingSurvey;
  }

  setIsViewingSurvey = (isViewingSurvey) => {
    this.setState({ isViewingSurvey });

    if (!isViewingSurvey && this.props.isViewingSurvey) {
      setTimeout(() => {
        this.props.taraSetIsViewingSurvey(false);
      }, TaraSurvey.ANIMATION_DURATION_MS);
    }
  };

  setHasMadeIntroduction = () => {
    if (!this.props.hasMadeIntroduction) {
      this.props.taraSetHasMadeIntroduction(true);
    }
  };

  submitForm = (form) => {
    this.setHasMadeIntroduction();

    if (!this.hasSubmitted) {
      this.hasSubmitted = true;
      this.props.taraPostSurveyRequest(form);
    }
  };

  handleCancel = (e, form) => {
    this.setIsViewingSurvey(false);
    this.submitForm(form);

    if (this.hasSubmitted)  {
      this.props.analyticsRecordActionRequest('survey','close', '');
    } else {
      this.props.analyticsRecordActionRequest('survey','cancel', '');
    }
  };

  handleStart = () => {
    this.hasSubmitted = false;
  }

  handleSubmit = (e, form) => this.submitForm(form);

  render() {
    return (
      <TaraSurvey
        {...this.props}
        isOpen={this.shouldRenderSurvey}
        isAnimated
        onCancel={this.handleCancel}
        onSubmit={this.handleSubmit}
        onStart={this.handleStart}
        isFetching={this.props.isFetching}
        status={this.props.status}
      />
    );
  }
}

const getState = (state, ownProps) => ({
  survey: getTaraSurvey(state),
  isViewingSurvey: getTaraIsViewingSurvey(state),
  hasAnsweredSurvey: getTaraHasAnsweredSurvey(state),
  hasMadeIntroduction: getTaraHasMadeIntroduction(state),
  isFetching: getIsFetching(state),
  status: getStatus(state),
  userId: getUserId(state),
  ...ownProps,
});

const getActions = dispatch => bindActionCreators({
  ...actions,
  ...analyticsActions,
}, dispatch);

export default connect(getState, getActions)(TaraSurveyContainer);



// WEBPACK FOOTER //
// ./src/containers/TaraSurveyContainer.js